import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Navbar from './components/layout/Navbar'
import Navbar2 from './components/layout/Navbar2'
import Dashboard from './components/dashboard/Dashboard'
import Redirector from './components/dashboard/Redirector'
import NewDashboard from './components/dashboard/NewDashboard'
import BotDashboard from './components/dashboard/BotDashboard'
import AdminDashboard from './components/dashboard/AdminDashboard'
import UserDashboard from './components/dashboard/UserDashboard'
import SignIn from './components/auth/SignIn2'
import SignUp from './components/auth/SignUp'
import CreateRestaurant from './components/restaurants/CreateRestaurant'
import RestaurantList from './components/restaurants/RestaurantList'
import EditRestaurant from './components/restaurants/EditRestaurant'
import EditPendingCreate from './components/restaurants/EditPendingCreate'
import PendingEditRestaurant from './components/restaurants/PendingEditRestaurant'
import AdminEditRestaurant from './components/restaurants/admin/AdminEditRestaurant'
import Messenger from './components/users/Messenger'
import Reviewer from './components/users/Reviewer'
import Contact from './components/users/Contact'
import Settings from './components/users/Settings'
import NewSettings from './components/users/NewSettings'
import SortingOptions from './components/users/SortingOptions'
import Support from './components/users/Support'
import MessengerReview from './components/users/MessengerReview2'
import MessengerIssue from './components/users/MessengerIssue'
import { connect } from 'react-redux'
import { firestoreConnect, firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import firebase from 'firebase/app'
import Burger from './components/layout/Burger'
import About from './components/layout/About'
import Blog from './components/layout/Blog'
import ScrollToTop from './components/layout/ScrollToTop'
import GenerateHTML from './components/layout/GenerateHTML'
import Game from './components/game/Game'
import GameInProgress from './components/game/GameInProgress'
import ChooseRestaurant from './components/game/ChooseRestaurant'
import NewChooseRestaurant from './components/game/NewChooseRestaurant'
import Tournament from './components/game/Tournament'
import Bracket from './components/game/Bracket'
import FromCSV from './components/fromCSV/FromCSV'
import TagLinks from './components/restaurants/TagLinks'
import Reddit from './components/reddit/Reddit'
import RedditMerge from './components/reddit/RedditMerge'
import RedditCount from './components/reddit/RedditCount'

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      reviewListeners: [],
      userListeners: false
    };
  }

  componentDidUpdate(props){
    if(this.props.user && this.props.uid !== 'X9cY4fGY1qXqZ0iW1cic26GlTkK2'){ 
      if(this.props.auth && !this.state.userListeners){
            //console.log('setting user listeners')
            this.props.firestore.unsetListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'messages' }
              ],
              storeAs: 'messages'
            })
            this.props.firestore.setListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'messages' }
              ],
              storeAs: 'messages'
            })
            this.props.firestore.unsetListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'reviewMessages' }
              ],
              storeAs: 'reviewMessages'
            })
            this.props.firestore.setListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'reviewMessages' }
              ],
              storeAs: 'reviewMessages'
            })
            this.props.firestore.unsetListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'issueMessages' }
              ],
              storeAs: 'issueMessages'
            })
            this.props.firestore.setListener({
            collection: 'users',
              doc: this.props.auth.uid,
              subcollections: [
                { collection: 'issueMessages' }
              ],
              storeAs: 'issueMessages'
            })
            this.setState({userListeners:true});                 
      }
    }
  }

  render() {
    return (
      <BrowserRouter>
      <ScrollToTop/>
        <div className="App">
          <Burger/>
          <Navbar/>
          <Navbar2/>
          <Switch>
            <Route exact path='/'component={Redirector} />
            <Route exact path='/NewDashboard'component={NewDashboard} />
            <Route path='/BotDashboard' component={BotDashboard} />
            <Route path='/AdminDashboard' component={AdminDashboard} />
            <Route path='/UserDashboard/:id' component={UserDashboard} />
            <Route path='/edit/:id' component={EditRestaurant} />
            <Route path='/editCreate/:id' component={EditPendingCreate} />
            <Route path='/adminEdit/:id' component={AdminEditRestaurant} />
            <Route path='/pendingEdit/:id' component={PendingEditRestaurant} />
            <Route path='/signin' component={SignIn} />
            <Route path='/signup' component={SignUp} />
            <Route path='/create' component={CreateRestaurant} />
            <Route path='/list' component={RestaurantList} />
            <Route path='/message/:userId/:messageId/:adminMessageId' component={Messenger} />
            <Route path='/reviewMessage/:userId/:messageId/:adminMessageId' component={MessengerReview} />
            <Route path='/issueMessage/:userId/:messageId/:adminMessageId' component={MessengerIssue} />
            <Route path='/reviews/:restaurantId' component={Reviewer} />
            <Route path='/contact' component={Contact} />
            <Route path='/about' component={About} />
            <Route path='/generateHTML' component={GenerateHTML} />
            <Route path='/blog' component={Blog} />
            <Route path='/settings' component={Settings} />
            <Route path='/support' component={Support} />
            <Route path='/game/:gameId' component={Game} />
            <Route path='/gameInProgress/:gameId' component={GameInProgress} />
            <Route path='/chooseRestaurant/:gameId/:choice' component={ChooseRestaurant} />
            <Route path='/newChooseRestaurant/:gameId/:choice' component={NewChooseRestaurant} />
            <Route path='/tournament/:gameId' component={Tournament} />
            <Route path='/bracket/:gameId' component={Bracket} />
            <Route path='/csv' component={FromCSV} />
            <Route path='/tagLinks' component={TagLinks} />
            <Route path='/reddit/:restaurant' component={Reddit} />
            <Route path='/redditMerge' component={RedditMerge} />
            <Route path='/redditCount' component={RedditCount} />
            <Route path='/sortingOptions' component={SortingOptions} />

          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurants: state.firestore.ordered.restaurants,
    redditCount: state.firestore.ordered.redditCount,
    users: state.firestore.ordered.users,
    restaurantReviews2: state.firestore.data.restaurantReviews2,
    pending: state.firestore.ordered.pending,
    pendingCreate: state.firestore.ordered.pendingCreate,
    pendingReviews: state.firestore.ordered.pendingReviews,
    advertisements: state.firestore.ordered.advertisements2,
    user
  }
}

export default compose(
  connect(mapStateToProps),
  firebaseConnect(props=>{if(props.auth.uid === "KXyK1sbPuOQamITgwh8c1gSAxOq2"){return[
    { path: 'pendingCreate', queryParams: ['orderByKey', 'limitToFirst=10' ] }
  ]}}),
  firestoreConnect(props =>{
    if(props.auth.uid === "KXyK1sbPuOQamITgwh8c1gSAxOq2"){
      return[
        { collection: 'restaurants' },
        { collection: 'redditCount' },
        { collection: 'users' },
        { collection: 'restaurantReviews2' },
        { collection: 'pending' },
        { collection: 'pendingReviews' },
        { collection: 'pendingCreate' },
        { collection: 'favorites'},
        { collection: 'points' },
        { collection: 'issues' },
        { collection: 'advertisements2' },
        { collection: 'games' },
        { collection: 'GUDistanceList' },
        { collection: 'redditNotRelevant' },
        { collection: 'deletedGames' }
        ]  
    }
    else if(props.auth.uid){
      return[
        { collection: 'restaurants' },
        { collection: 'redditCount' },        
        { collection: 'users', doc: props.auth.uid },
        { collection: 'restaurantReviews2' },
        { collection: 'pending', where: [['editorId', '==', props.auth.uid]] },
        { collection: 'pendingCreate', where: [['authorId', '==', props.auth.uid]] },
        { collection: 'pendingReviews', where: [['userId', '==', props.auth.uid]] },
        { collection: 'favorites'},
        { collection: 'points' },
        { collection: 'issues', where: [['userId', '==', props.auth.uid]] },
        { collection: 'advertisements2' },
        { collection: 'games' },
        { collection: 'GUDistanceList' }
        ]  
    }
    else{
      return[
      { collection: 'advertisements2' },
      { collection: 'GUDistanceList' }
      ]
    }
    })
)(App)